// client/src/components/PublicNavbar.tsx
"use client";

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { BadgePoundSterling, Coins, BookOpen, Wrench } from 'lucide-react';

export default function PublicNavbar() {
    return (
        <div className="fixed top-0 left-0 right-0 z-50 mx-4 animate-navbar-drop-in">
            <nav className="mt-0 sm:mt-4 p-0 sm:p-4" style={{ paddingTop: 0 }}>
                <div style={{ background: "rgba(255, 255, 255, 0.70)" }} className="backdrop-blur-sm bg-opacity-99 max-w-7xl mx-auto px-4 mt-4 sm:mt-0 sm:px-8 md:px-8 bg-opacity-100 lg:px-8 border-2 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] ">
                    <div className="flex justify-between h-16">
                        <div className="flex-shrink-0 flex items-center">
                            <Link href="/" className="flex items-center gap-2">
                                <Image
                                    src="/logo.svg"
                                    alt="Delphina"
                                    width={32}
                                    height={32}
                                    className="h-8 w-auto"
                                    priority
                                />
                                <span className="text-2xl text-positive-600" style={{ letterSpacing: '-0.05em', fontWeight: 800 }}>
                                    Delphina.
                                </span>
                            </Link>
                        </div>
                        <div className="hidden sm:ml-6 md:flex sm:space-x-8">
                            <Link
                                href="/pricing"
                                className="border-transparent text-gray-500 hover:border-accent-positive hover:text-positive-500 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                            >
                                <BadgePoundSterling className="h-4 w-4 mr-1.5" />
                                Pricing
                            </Link>
                            <Link
                                href="/features"
                                className="border-transparent text-gray-500 hover:border-accent-positive hover:text-positive-500 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                            >
                                <Coins className="h-4 w-4 mr-1.5" />
                                Solutions
                            </Link>
                            <Link
                                href="/guides"
                                className="border-transparent text-gray-500 hover:border-accent-positive hover:text-positive-500 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                            >
                                <BookOpen className="h-4 w-4 mr-1.5" />
                                Guides
                            </Link>
                            <Link
                                href="/tools"
                                className="border-transparent text-gray-500 hover:border-accent-positive hover:text-positive-500 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                            >
                                <Wrench className="h-4 w-4 mr-1.5" />
                                Tools
                            </Link>
                        </div>
                        <div className="flex items-center">
                            <Link
                                href="/login"
                                data-testid="main_sign_up"
                                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-semibold shadow-sm text-white bg-positive-600 hover:bg-positive-700 transform hover:scale-105 transition-all duration-200"
                            >
                                Sign in / up
                            </Link>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
}
